import { type ContentChildComponent } from '@johnlewispartnership/wtr-aem-components/dist/common/types';
import { getExperienceFragmentById } from '@/services/content/get-experience-fragment-by-id';
import { getHomePageRecommendedProducts } from '@/services/products/get-home-page-recommended-products';
import { cached } from '@/services/common/utils/mem-cache';
import { type Product } from '@/services/products/types';
import httpContext from 'express-http-context';
import HomePage from '@/views/HomePage/HomePage';
import { type HomePageProps } from '@/views/HomePage/types';

const getCachedExperienceFragmentById = async (): Promise<ContentChildComponent[]> =>
  cached(
    'home-page-aem-fragment',
    () => getExperienceFragmentById('home_page/home-page-fragment'),
    60_000,
  );

const getCachedRecommendedProducts = async (): Promise<Product[]> =>
  cached('home-page-recommended-products', getHomePageRecommendedProducts, 60_000);

export async function getServerSideProps(): Promise<{ props: HomePageProps }> {
  const nonce = httpContext.get('x-nonce') as string;
  const [contentNodes, recommendedProducts] = await Promise.all([
    getCachedExperienceFragmentById(),
    getCachedRecommendedProducts(),
  ]);
  return { props: { contentNodes, nonce, recommendedProducts } };
}

export default HomePage;
